import { Component, ViewChild, TemplateRef, ChangeDetectorRef, ComponentFactoryResolver, SecurityContext, ViewContainerRef } from "@angular/core";
import { ComponentRef } from '@angular/core';
import { Type } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IadMessageConfig, IAdMessageBody } from '../adMessageConfig';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';


@Component({
  selector: 'ad-dynamicmessage',
  templateUrl: './ad-dynamicmessage.component.html',
  styleUrls: ['./ad-dynamicmessage.component.scss']
})
export class AdDynamicMessage {
  bodyContext: any = null;
  bodyTemplate: TemplateRef<any> = null;
  bodyTemplateContext: any = null;
  footerTemplate: TemplateRef<any> = null;
  footerTemplateContext: any = null;
  bodyComponentType: Type<IAdMessageBody> = null;
  data: IadMessageConfig = null;
  bodyComponentRef: ComponentRef<IAdMessageBody>;
  isForComponent?: boolean = false;
  innerHTML: string = null;
  l1text: string;
  l2text: string[];
  messageStyle: any = null;
  messageStyleClass: any = null;
  titleClass: any = null;
  header: string;
  headerTemplate: TemplateRef<any> = null;
  headerTemplateContext: any = null;
  closable: boolean;
  showHeader: boolean = true;

  mainButtonText: string;
  secondaryButtonText: string;

  doNotShowAgain: boolean;
  doNotShowAgainMsg: string = "Do not show this message again";
  isShowMessageAgainVisible: boolean = true;

  // isMainButtonDisable$: Observable<boolean>;
  // isSecondaryButtonDisable$: Observable<boolean>;

  //mainbuttonDisableSubscribe: any;
  mainbuttonDisableFun: () => boolean = null;

  _isMainButtonDisable: boolean = false;
  get isMainButtonDisable() {
    if (this.bodyComponentRef != null && 'isMainButtonDisable' in this.bodyComponentRef.instance) {
      return this.bodyComponentRef.instance.isMainButtonDisable;
    } else if (this.mainbuttonDisableFun != null && typeof (this.mainbuttonDisableFun) === 'function') {
      return this.mainbuttonDisableFun();
    }
    else {
      return this._isMainButtonDisable;
    }
  }

  isSecondaryButtonHidden: boolean = false;

  @ViewChild('insertPoint', { read: ViewContainerRef }) templateContainer: ViewContainerRef;
  @ViewChild('defaultBody') defaultBody: TemplateRef<any>;
  @ViewChild('innerHtmlBody') htmlBody: TemplateRef<any>;
  @ViewChild('defaultHeader') defaultHeader: TemplateRef<any>;

  constructor(public config: DynamicDialogConfig,
    public cd: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private sanitizer: DomSanitizer,
    private dialogRef: DynamicDialogRef
  ) {
    this.data = this.config.data as IadMessageConfig;
    this.headerTemplate = this.config.data.headerTemplate;
    this.headerTemplateContext = this.config.data.headerTemplateContext;
    this.showHeader = this.config.data.showHeader;
    this.header = this.config.data.titleText;
    this.bodyTemplate = this.data.bodyTemplate;
    this.bodyTemplateContext = this.data.bodyTemplateContext;
    this.footerTemplate = this.data.footerTemplate;
    this.footerTemplateContext = this.data.footerTemplateContext;
    this.bodyComponentType = this.data.componentType;
    this.isForComponent = this.bodyComponentType != null;
    this.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, this.data.innerHtml);
    this.mainButtonText = this.data.mainPathText;
    this.secondaryButtonText = this.data.secondaryPathText;
    this.isShowMessageAgainVisible = this.data.isShowMessageAgainVisible;
    this.l1text = this.data.l1Text;
    this.l2text = (this.data.l2Text instanceof Array ? [...this.data.l2Text] : [this.data.l2Text]).filter(it => it && it.length);
    this.messageStyle = this.data.messageStyle;
    this.messageStyleClass = this.data.messageStyleClass;
    this.titleClass = this.data.titleClass;
    this.isSecondaryButtonHidden = this.data.isSecondaryButtonHidden;
    this.mainbuttonDisableFun = this.data.isMainPathDisable;
    if (this.data.doNotShowAgainMsg) {
      this.doNotShowAgainMsg = this.data.doNotShowAgainMsg;
    }



    // this.mainbuttonDisableSubscribe = (this.data as any)
    //   .mainbuttonDisable$
    //   .subscribe(val => {
    //     this._isMainButtonDisable = val;
    //   });
  }

  ngAfterViewInit() {
    if (this.isForComponent) {
      this.loadChildComponent(this.bodyComponentType);
    }
    else if (this.bodyTemplate != null) {
      this.templateContainer.createEmbeddedView(this.bodyTemplate, this.bodyTemplateContext);
    }
    else if (this.innerHTML && this.innerHTML.length > 0) {
      this.templateContainer.createEmbeddedView(this.htmlBody);
    }
    else {
      this.templateContainer.createEmbeddedView(this.defaultBody);
    }
    this.cd.detectChanges();
  }

  loadChildComponent(componentType: Type<any>) {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
    this.templateContainer.clear();

    this.bodyComponentRef = this.templateContainer.createComponent(componentFactory);
    this.bodyComponentRef.instance.data = this.data.componentViewModel;
    if (this.data.inputs && Object.keys(this.data.inputs).length) {
      Object.assign(this.bodyComponentRef.instance, this.data.inputs || {});
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.bodyComponentRef) {
      this.bodyComponentRef.destroy();
    }
    // if (this.mainbuttonDisableSubscribe) {
    //   this.mainbuttonDisableSubscribe.unsubscribe();
    // }
  }

  onMainButtonClick() {
    if (this.data.onOk) {
      this.data.onOk({
        bodyInstance: this.bodyComponentRef?.instance,
        closeMe: () => this.close(),
        doNotShowAgain: this.doNotShowAgain
      });
    }
    // This branch is deprecated, please use onOk function instead,
    // we keep it here to support legacy code but will remove in the future
    else if (this.data.mainPathCallBack) {
      this.data.mainPathCallBack(this.doNotShowAgain, this.bodyComponentRef?.instance?.returnParam);
    }
    else {
      this.close();
    }
  }

  onSecondaryButtonClick() {
    if (this.data.onCancel) {
      this.data.onCancel({
        bodyInstance: this.bodyComponentRef?.instance,
        closeMe: () => this.close(),
        doNotShowAgain: this.doNotShowAgain
      });
    }
    // This branch is deprecated, please use onOk function instead,
    // we keep it here to support legacy code but will remove in the future
    else if (this.data.secondaryPathCallBack) {
      this.data.secondaryPathCallBack();
    }
    else {
      this.close();
    }
  }

  close() {
    this.dialogRef.destroy();
  }
}
